function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#616161;stroke:#616161;stroke-miterlimit:10;}\n\t.st1{fill:#616161;}\n\t.st2{fill:#FDFEFF;}\n\t.st3{fill:none;stroke:#616161;stroke-miterlimit:10;}\n\t.st4{fill:#616161;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{display:none;fill:#FFFFFF;}\n\t.st7{display:none;fill:#616161;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st8{fill:#BDBDBD;}\n\t.st9{fill:none;stroke:#616161;stroke-linecap:round;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Capa_1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Capa_2"
}, React.createElement("g", {
  id: "loteado_1_"
}, React.createElement("rect", {
  x: 23.5,
  y: 19.29,
  className: "st8",
  width: 16.47,
  height: 2.25
}), React.createElement("rect", {
  x: 26.91,
  y: 22.25,
  className: "st8",
  width: 16.59,
  height: 2.25
}), React.createElement("rect", {
  x: 23.5,
  y: 25.2,
  className: "st8",
  width: 16.47,
  height: 2.25
}), React.createElement("rect", {
  x: 27.03,
  y: 28.15,
  className: "st8",
  width: 16.47,
  height: 2.25
}), React.createElement("rect", {
  x: 26.91,
  y: 16.5,
  className: "st8",
  width: 16.59,
  height: 2.25
}), React.createElement("path", {
  className: "st8",
  d: "M0.7,16.64v13.72h20V16.64H0.7z M2.81,29.53H1.4V17.47h1.4V29.53z M5.26,29.53h-1.4V17.47h1.4V29.53z  M7.72,29.53h-1.4V17.47h1.4V29.53z M10.18,29.53h-1.4V17.47h1.4V29.53z M12.63,29.53h-1.4V17.47h1.4V29.53z M15.09,29.53h-1.4 V17.47h1.4V29.53z M17.54,29.53h-1.4V17.47h1.4V29.53z M20,29.53h-1.4V17.47H20V29.53z"
})));

var SvgCobreLoteado = function SvgCobreLoteado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCobreLoteado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cobre-loteado.b9229651.svg";
export { ForwardRef as ReactComponent };